import { IconComponent } from './types';

const SearchIcon: IconComponent = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M7.75 7h-.395l-.14-.135a3.25 3.25 0 1 0-.35.35l.135.14v.395l2.5 2.495.745-.745L7.75 7Zm-3 0A2.247 2.247 0 0 1 2.5 4.75 2.247 2.247 0 0 1 4.75 2.5 2.247 2.247 0 0 1 7 4.75 2.247 2.247 0 0 1 4.75 7Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SearchIcon;
